import { render, staticRenderFns } from "./AgeVerificationInputFile.vue?vue&type=template&id=10cf5e48&scoped=true&"
import script from "./AgeVerificationInputFile.vue?vue&type=script&lang=ts&"
export * from "./AgeVerificationInputFile.vue?vue&type=script&lang=ts&"
import style0 from "./AgeVerificationInputFile.vue?vue&type=style&index=0&id=10cf5e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cf5e48",
  null
  
)

export default component.exports